<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-else>
      <v-row>
        <v-col xs="12" sm="12" md="8" lg="10" xl="10" cols="12">
          <div class="title_page ma-3">
            <h4 class="breadcrumb_title_page">แก้ไขข้อมูลสินค้า</h4>
            <v-breadcrumbs :items="sub_menu">
              <template v-slot:divider>
                <v-icon>mdi-chevron-right</v-icon>
              </template>
            </v-breadcrumbs>
          </div>
        </v-col>
        <v-col xs="12" sm="12" md="4" lg="2" xl="2" cols="12">
          <div class="title_page ma-3">
            <v-btn type="button" class="btn_back_page" elevation="4" @click="$router.back()" large>ย้อนกลับ</v-btn>
          </div>
        </v-col>
      </v-row>

      <v-card elevation="4" style="border-radius: 15px;">
        <v-card-text>
          <div class="mt-3 pa-4">
            <v-form ref="form" @submit.prevent="editProductStore()">
              <v-row>
                <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                  <div class="d-flex">
                    <div class="title_form_main">
                      <div class="logo_timeline">
                        <img src="@/assets/arin_assets/box.png">
                      </div>
                    </div>
                    <div class="header-content py-1 pl-5 pr-5 text-center">
                      <div class="content-font">ข้อมูลสินค้า</div>
                    </div>
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col xs="12" sm="6" md="6" lg="4" xl="3" cols="12" style="padding-left: 50px;">
                  <v-form-group>
                    <v-file-input id="fileUpload_product" accept="image/*" @change="onFileChange_product" prepend-icon=""
                      v-model="product.picture" hide-input />
                      <label class="label_form_text pl-4">รูปภาพสินค้า <span class="required--text">(ขนาดไม่เกิน 500x500 พิกเซล)</span></label>
                    <v-img v-if="image_product_preview !== null" :lazy-src="image_product_preview" :src="image_product_preview"
                      class="preview profile_img">
                      <v-btn elevation="4" class="mt-2 btn_edit_logo" outlined color="#FEA06C" @click="getFile_product"
                        title="อัพโหลดรูปพนักงาน">
                        <v-icon>mdi-pencil</v-icon>
                      </v-btn>
                    </v-img>
                    <v-img v-else :lazy-src="img_holder" :src="img_holder" class="preview profile_img">
                      <v-btn elevation="4" class="mt-2 btn_edit_logo" outlined color="#FEA06C" title="อัพโหลดรูปพนักงาน"
                        @click="getFile_picture">
                        <v-icon>mdi-pencil</v-icon>
                      </v-btn>
                    </v-img>
                  </v-form-group>
                </v-col>
              </v-row>

              <v-row style="padding-left: 50px;">
                <v-col xs="12" sm="12" md="6" lg="6" xl="6" cols="12">
                  <v-form-group>
                    <label class="label_form_text">ชื่อสินค้า <span class="required--text">*</span></label>
                    <v-text-field color="#D6BFAF" class="input-radius" prepend-inner-icon="mdi-cube"
                      v-model="product.name" hide-details="auto" :rules="[v => !!v || 'กรุณากรอกข้อมูล']"
                      placeholder="ชื่อสินค้า" single-line outlined dense required></v-text-field>
                  </v-form-group>
                </v-col>
                <v-col xs="12" sm="12" md="6" lg="6" xl="6" cols="12">
                  <v-form-group>
                    <label class="label_form_text">ชื่อทางการแพทย์</label>
                    <v-text-field color="#D6BFAF" class="input-radius" prepend-inner-icon="mdi-credit-card"
                      hide-details="auto" v-model="product.name_sci"
                      placeholder="กรุณากรอกชื่อทางการแพทย์ " single-line outlined dense required></v-text-field>
                  </v-form-group>
                </v-col>

                <v-col xs="12" sm="6" md="4" lg="4" xl="4" cols="12">
                    <v-form-group>
                      <label class="label_form_text">ประเภทสินค้า <span class="required--text">*</span></label>
                      <v-autocomplete color="#D6BFAF" class="input-radius align-center" :items="list_type" item-text="name"
                        item-value="id" v-model="product.product_type" hide-details="auto" prepend-inner-icon="mdi-cube"
                        :rules="[v => !!v || 'กรุณาเลือกประเภทสินค้า']" placeholder="กรุณาเลือกประเภทสินค้า" single-line outlined dense
                        required></v-autocomplete>
                    </v-form-group>
                </v-col>

                <v-col xs="12" sm="6" md="4" lg="4" xl="4" cols="12">
                  <v-form-group>
                    <label class="label_form_text">จำนวนสินค้าในคลังสูงสุด <span
                        class="required--text">*</span></label>

                    <v-text-field color="#D6BFAF" v-model="product.max" class="input-radius" prepend-inner-icon="mdi-cube" hide-details="auto"
                      @keypress="isTaxNumber($event, product.max)" :rules="[v => !!(v+'').length > 0  || 'กรุณากรอกจำนวนสินค้าในคลังสูงสุด']"
                      placeholder="กรุณากรอกจำนวนสินค้าในคลังสูงสุด" single-line outlined dense
                      required></v-text-field>
                  </v-form-group>
                </v-col>

                <v-col xs="12" sm="6" md="4" lg="4" xl="4" cols="12">
                  <v-form-group>
                    <label class="label_form_text">จำนวนสินค้าในคลังไม่ควรน้อยกว่า <span
                        class="required--text">*</span></label>

                    <v-text-field color="#D6BFAF" class="input-radius" prepend-inner-icon="mdi-cube" hide-details="auto"
                      v-model="product.min" @keypress="isTaxNumber($event, product.min)" :rules="[v => parseFloat(v) <= product.max || 'จำนวนสินค้าในคลังเกินจำนวนสูงสุด', v => !!(v+'').length > 0 || 'กรุณากรอกจำนวนสินค้าในคลังไม่ควรน้อยกว่า']"
                      placeholder="กรุณากรอกจำนวนสินค้าในคลังไม่ควรน้อยกว่า" single-line outlined dense
                      required></v-text-field>
                  </v-form-group>
                </v-col>
                <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                  <v-form-group>
                    <label class="label_form_text">รายละเอียด </label>
                    <v-textarea color="#D6BFAF" class="input-radius" hide-details="auto" :maxlength="1500"
                      v-model="product.detail" single-line outlined dense required></v-textarea>
                  </v-form-group>
                </v-col>
              </v-row>
              <v-row>
                <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                  <div class="d-flex">
                    <div class="title_form_main">
                      <div class="logo_timeline">
                        <img src="@/assets/arin_assets/cycle.png">
                      </div>
                    </div>
                    <div class="header-content py-1 pl-5 pr-5 text-center">
                      <div class="content-font">ข้อมูลหน่วยนับ</div>
                    </div>
                  </div>
                </v-col>
              </v-row>
              
              <v-row v-for="(unit, index) in filteredUnitList" :key="index" style="padding-left: 50px;">
                <v-col xs="12" sm="4" md="2" lg="2" xl="2" cols="12" class="pb-0">
                  <v-form-group>
                    <label class="label_form_text">หน่วยนับ <span class="required--text">*</span></label>
                    <v-autocomplete color="#D6BFAF" class="input-radius align-center"
                      :items="select_unit" item-text="name" item-value="id" v-model="unit.unit_id"
                      hide-details="auto" :rules="[v => !!v || 'กรุณาเลือกหน่วยนับ']" placeholder="หน่วยนับ" single-line
                      outlined dense required></v-autocomplete>
                  </v-form-group>
                </v-col>
                <v-col xs="12" sm="8" md="4" lg="4" xl="4" cols="12" class="pb-0">
                  <label class="label_form_text">บาร์โค๊ด <span class="required--text">*</span></label>
                  <div class="d-flex">
                    <v-text-field color="#D6BFAF" class="input-radius align-center mr-2" v-model="unit.barcode"
                      @keypress="isNumber($event, unit.barcode)" @paste="isPaste($event)" hide-details="auto" :rules="[v => !!v || 'กรุณากรอกบาร์โค๊ด']"
                      single-line outlined dense required>
                    </v-text-field>
                    <v-btn outlined color="#8EBBDC" class="input-radius" @click="make_id(index);"
                      style=" min-width: 38px !important; padding: 0 9px !important;">
                      <v-icon>
                        mdi-barcode-scan
                      </v-icon>
                    </v-btn>
                  </div>
                </v-col>
                <v-col xs="12" sm="4" md="2" lg="2" xl="2" cols="12" class="pb-0">
                  <label class="label_form_text">ราคาขายปลีก <span class="required--text">*</span></label>
                  <v-text-field color="#D6BFAF" class="input-radius align-center" v-model="unit.price_standard" type="number"
                    @keypress="isDecimal($event, unit.price_standard)" @paste="isPaste($event)" hide-details="auto" :rules="[v => !!v || 'กรุณากรอกราคาขายปลีก']"
                    single-line outlined dense required>
                  </v-text-field>
                </v-col>
                <v-col xs="12" sm="4" md="2" lg="2" xl="2" cols="12" class="pb-0">
                  <label class="label_form_text">ราคาสมาชิก</label>
                  <v-text-field color="#D6BFAF" class="input-radius align-center" v-model="unit.price_register" type="number"
                    @keypress="isDecimal($event, unit.price_register)" @paste="isPaste($event)" hide-details="auto"
                    single-line outlined dense required>
                  </v-text-field>
                </v-col>
                <v-col xs="12" sm="4" md="2" lg="2" xl="2" cols="12" class="pb-0">
                  <label class="label_form_text">ราคาพนักงาน</label>
                  <div class="d-flex">
                    <v-text-field color="#D6BFAF" class="input-radius align-center" :class="index != 0 ? 'mr-2' : ''" v-model="unit.price_employee" type="number"
                      @keypress="isDecimal($event, unit.price_employee)" @paste="isPaste($event)" hide-details="auto"
                      single-line outlined dense required>
                    </v-text-field>
                    <v-btn v-if="index != 0" type="button" outlined color="error" class="input-radius" @click="deleteUnit(unit.add_unit_id);"
                      style=" min-width: 38px !important; padding: 0 9px !important;">
                      <v-icon>
                        mdi-delete
                      </v-icon>
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
              
              <v-row>
                <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12" style="text-align: right;">
                  <v-btn type="button" elevation="4" style="border-radius: 10px;font-size: 16px;" outlined @click="addUnit()"
                    color="#88B358">เพิ่มหน่วยนับ</v-btn>
                </v-col>
              </v-row>
              <v-row>
                <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                  <div class="title_page ma-3" style="justify-content:center;">
                    <v-btn type="submit" class="btn_add_data" elevation="4" large>บันทึก</v-btn>
                  </div>
                </v-col>
              </v-row>
            </v-form>
          </div>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
import img_holder from "@/assets/arin_assets/image_sun_color.png";
import { HTTP_ARIN } from "@/axios_arin";
import Swal from "sweetalert2";
import { isBarcode, taxNumber, validateEmail, onPaste, onlyForCurrency } from "@/js/handler";

export default {
  inject: {
    theme: {
      default: {
        isDark: false,
      },
    },
  },
  name: "Pos_edit_product_data",
  data() {
    return {
      loading_page: false,
      sub_menu: [
        {
          text: 'ระบบ POS',
          disabled: false,
        },
        {
          text: 'คลังสินค้า',
          disabled: false,
        },
        {
          text: 'รายการสินค้า',
          disabled: false,
        },
        {
          text: 'แก้ไขข้อมูลสินค้า',
          disabled: false,
          href: '#',
        },
      ],
      img_holder: img_holder,
      image_product_preview: null,
      product: {
        picture: null,
        name: '',
        name_sci: '',
        max: '',
        min: '',
        detail: '',
        product_type: '',
        product_pharma_status: 1,
      },
      list_type: [],
      select_type: null,
      test: [],
      select_unit: [],
      add_unit_id: 1,
      unit_list: [{
        add_unit_id: 1,
        unit_id: null,
        unit_main: 1,
        barcode: '',
        price_standard: '',
        price_register: '',
        price_employee: '',
      }],
    }
  },
  methods: {
    // GET ข้อมูลสินค้า
    async getProductDetail() {
      const config = { headers: { "Authorization": `Bearer ${this.$store.state.store_arin.access_token}` } }
      await HTTP_ARIN.get('/product/unitlist', config).then((res) => {
        if (res.data.successful === true) {
          this.select_unit = res.data.unitList;
        }
      })
      await HTTP_ARIN.get('/product/productdetail/' + this.$route.params.id, config).then((res) => {
        if (res.data.successful === true) {
          this.product.name = res.data.product_detail[0].name
          this.product.name_sci = res.data.product_detail[0].name_sci
          this.product.product_type = res.data.product_detail[0].product_type_id
          this.product.max = parseInt(res.data.product_detail[0].max) 
          this.product.min = parseInt(res.data.product_detail[0].min)
          this.product.detail = res.data.product_detail[0].detail
          this.product.product_code = res.data.product_detail[0].product_code
          if (res.data.product_detail[0].picture) {
            this.img_holder = res.data.product_detail[0].picture
          }
          const count_data = res.data.product_detail.length
          this.unit_list = []
          for (let index = 0; index < count_data; index++) {
            this.unit_list.push({
              id: res.data.product_detail[index].product_list_id,
              add_unit_id: this.add_unit_id,
              unit_id: res.data.product_detail[index].unit_id,
              unit_main: res.data.product_detail[index].unit_main,
              barcode: res.data.product_detail[index].barcode,
              price_standard: res.data.product_detail[index].price_standard,
              price_register: res.data.product_detail[index].price_register,
              price_employee: res.data.product_detail[index].price_employee,
              is_delete: 0,
            })
            this.add_unit_id += 1
          }
          this.loading_page = false;
        }
      })
    },

    // GET ประเภทสินค้าข้อมูลสินค้า
    getProductType() {
      const config = { headers: { "Authorization": `Bearer ${this.$store.state.store_arin.access_token}` } }
      HTTP_ARIN.get('/product/getpdtypelist', config).then((res) => {
        console.log(res.data.list);

        if (res.data.successful === true) {
          this.loading_page = false;
          this.list_type = res.data.list;
        }
      })
    },

    // ฟังค์ชั่น การกด input file
    getFile_picture() {
      let fileUpload = document.getElementById('fileUpload_product')
      if (fileUpload != null) {
        fileUpload.click()
      }
    },
    onFileChange_product(payload) {
      if (payload !== null && payload !== undefined) {
        const file = payload
        let extall = "png,PNG,jpeg,JPEG,jpg,JPG";
        let file_ext = file.name;
        let ext = file_ext.split('.').pop().toLowerCase();
        if (parseInt(extall.indexOf(ext)) < 0) {
          Swal.fire({
            text: 'อัพโหลดได้เฉพาะไฟล์ รูป หรือ (.png, .PNG, .jpeg, .JPEG, .jpg, .JPG)',
            icon: 'error',
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: `ตกลง`,
            denyButtonText: `ยกเลิก`,
          }).then(() => {
            this.image_product_preview = null
            this.unit.system_logo = null
          })
        } else {
          if (file) {
            this.image_product_preview = URL.createObjectURL(file)
            URL.revokeObjectURL(file)
          } else {
            this.image_product_preview = null
            this.unit.system_logo = null
          }
        }
      } else {
        this.image_product_preview = null
        this.unit.system_logo = null
      }
    },
    addUnit() {
      this.add_unit_id += 1;
      this.unit_list.push({
        id: null,
        add_unit_id: this.add_unit_id,
        unit_id: null,
        unit_main: 0,
        barcode: '',
        price_standard: '',
        price_register: '',
        price_employee: '',
        is_delete:0
      })
    },
    deleteUnit(id) {
      this.unit_list = this.unit_list.map(detail => {
        if (detail.add_unit_id === id) {
          detail.is_delete = 1;
        }
        return detail;
      });
    },
    make_id(index) {
      this.unit_list[index].barcode = ''
      let characters_number = '0123456789';
      let charactersLength = characters_number.length;
      for (let i = 0; i < 9; i++) {
        this.unit_list[index].barcode += characters_number.charAt(Math.floor(Math.random() * charactersLength));
      }
    }, 
    isNumber: function (evt, number) {
      return isBarcode(evt, number)
    }, 
    isDecimal: function (evt, number) {
      return onlyForCurrency(evt, number)
    },
    isTaxNumber: function (evt, number) {
      return taxNumber(evt, number)
    },
    isEmail: function (evt) {
      return validateEmail(evt)
    },
    isPaste: function (evt) {
      return onPaste(evt)
    },
    checkDuplicateBarcode() {
      const barcodes = this.unit_list.map(unit => unit.barcode);
      const uniqueBarcodes = new Set(barcodes);
      if (barcodes.length !== uniqueBarcodes.size) {
        Swal.fire({
          title: 'Duplicate Barcode',
          text: 'มีบาร์โค๊ดซ้ำกัน กรุณาตรวจสอบ',
          icon: 'error',
          confirmButtonText: 'ตกลง'
        });
        return true;
      }
      return false;
    },
    async editProductStore(){
      if (this.$refs.form.validate() && !this.checkDuplicateBarcode()) {
        this.loading_page = true
        let data = new FormData()
       
        data.append('picture', this.product.picture)
        data.append('name', this.product.name)
        data.append('name_sci', this.product.name_sci)
        data.append('detail', this.product.detail)
        data.append('product_pharma_status', this.product.product_pharma_status)
        data.append('product_type', this.product.product_type)
        data.append('max', this.product.max)
        data.append('min', this.product.min)

        const count_unit = this.unit_list.length
        for (let index = 0; index < count_unit; index++) {
          data.append('id', this.unit_list[index].id ? this.unit_list[index].id : null)
          data.append('product_code', this.product.product_code)
          data.append(`unit_id`, this.unit_list[index].unit_id)
          data.append(`unit_main`, this.unit_list[index].unit_main)
          data.append(`barcode`, this.unit_list[index].barcode)
          data.append(`price_standard`, this.unit_list[index].price_standard)
          data.append(`price_register`, this.unit_list[index].price_register == '' ? 0 : this.unit_list[index].price_register)
          data.append(`price_employee`, this.unit_list[index].price_employee == '' ? 0 : this.unit_list[index].price_employee)
          data.append('is_delete', this.unit_list[index].is_delete)
        }
        const config = { headers: { "Authorization": `Bearer ${this.$store.state.store_arin.access_token}` } }
        HTTP_ARIN.post('/product/updateproduct/'+ this.$route.params.id,data, config).then((res) => {
          if (res.data.successful === true) {
            this.loading_page = false;
            let timerInterval
            Swal.fire({
              title: 'เสร็จสิ้น',
              text: 'แก้ไขข้อมูลเรียบร้อย',
              icon: 'success',
              timer: 2000,
              timerProgressBar: true,
              didOpen: () => {
                Swal.showLoading()
                timerInterval = setInterval(() => { })
              },
              willClose: () => {
                clearInterval(timerInterval)
                setTimeout(function () {
                  window.location.href = '/arin/pos/warehouseproductlist';
                });
              }
            })
          }
        })
      }
    },
  }, 
  mounted() {
    this.getProductDetail();
    this.getProductType();
  },
  computed: {
    filteredUnitList() {
      return this.unit_list.filter(unit => unit.is_delete === 0);
    }
  }
}
</script>


<style scoped>
.title_page h4.breadcrumb_title_page {
  font-size: 20px !important;
}

.content-font {
  color: #616A6B;
  font-weight: 500;
  font-size: 16px;
}

.title_form_main {
  background: #D6BFAF;
  z-index: 2;
  border-radius: 50%;
  box-shadow: 0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%);
  height: 38px;
  left: calc(50% - 19px);
  width: 38px;
}

.logo_timeline {
  padding: 6px;
}


.logo_timeline>img {
  max-width: 25px;
}


.input-radius {
  border-radius: 10px;
}

.grid_radio {
  display: flex;
  justify-content: space-around;
}

.preview {
  border-radius: 10px;
}

.preview.profile_img {
  max-width: 300px;
  border-radius: 30px;
}

.btn_edit_logo {
  border-radius: 10px;
  background-color: #FFF;
  position: absolute;
  top: 8px;
  right: 16px;
}


.input-radius {
  border-radius: 10px;
}

label.label_form_text {
  font-size: 16px !important;
  color: #616A6B !important;
}

.btn_add_data {
  font-size: 16px;
  color: #FFF;
  background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%), #88B358 !important;
  border-radius: 10px;
  width: 15%;
}

@media only screen and (min-width: 0px)AND (max-width: 361px) {}

@media only screen and (max-width: 600px) {

  .title_page h4.breadcrumb_title_page {
    font-size: 14px !important;
  }
}

@media only screen and (min-width: 601px) AND (max-width: 960px) {}

@media only screen and (min-width: 961px) AND (max-width: 1264px) {}

@media only screen and (min-width: 1265px) AND (max-width: 1904px) {}
</style>